import { useHistory } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import routeConfig from '@/config/routeConfig';

const PaymentFailure = () => {
	const history = useHistory();

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				minHeight: '60vh',
				gap: '16px',
				textAlign: 'center',
				padding: '24px',
			}}
		>
			<h2 style={{ fontSize: '1.5rem', fontWeight: '600' }}>
				El pago no pudo procesarse
			</h2>
			<p style={{ color: '#6b7280', maxWidth: '400px' }}>
				Ocurrió un problema al procesar tu pago. Por favor intenta de nuevo o
				escríbenos a{' '}
				<a
					href="mailto:contacto@cybersign.gt"
					style={{ color: '#2563eb', textDecoration: 'underline' }}
				>
					contacto@cybersign.gt
				</a>{' '}
				si el problema persiste.
			</p>
			<Button onClick={() => history.push(routeConfig.requestSignature)}>
				Reintentar
			</Button>
		</div>
	);
};

export default PaymentFailure;
